/**
 * Collect node IDs that are direct children of `if` nodes (considered optional — the
 * condition may skip them).
 *
 * NOTE: Only detects direct children. Deeper descendants (e.g. if → intermediate →
 * connector) are not included — covers current block structures but may need recursive
 * traversal later.
 */
export function getConditionalNodeIds(nodes: Record<string, { type: string; children: string[] }>): Set<string> {
  const conditionalNodeIds = new Set<string>();
  for (const node of Object.values(nodes)) {
    if (node.type === "if") {
      for (const childId of node.children) {
        conditionalNodeIds.add(childId);
      }
    }
  }
  return conditionalNodeIds;
}
